import { Component, ViewChild, EventEmitter, Output } from '@angular/core';
import { DispatchesService } from '../../shared/services/dispatches.service';
import * as _ from 'lodash';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { DispatchSummary } from '../../shared/models/DispatchSummary';
import { DQOIService } from '../../shared/services/DQOI.service';
import { SearchTarget } from '../../shared/enums/SearchTarget';
import { BaseDQOIComponent } from '../../shared/base-components/base-dqoi.component';
import { GlobalsService } from '../../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../../dqoi/state/dqoi-reference-data.query';
import { CommonFunctions } from '../../shared/static/common-functions';
import { DQOIState } from '../../shared/models/DQOIState';
import { DQOIItem } from '../../shared/models/DQOIItem';

import { SaveMode } from '../../shared/enums/SaveMode';
import { DbTable } from '../../shared/enums/DbTable';
import { v_LocationDetailBus } from '../../shared/models/v_LocationDetailBus';
import { QuoteLineItemsComponent } from '../../quotes/quote-lineitems/quote-lineitems.component';
import { QuoteNotesComponent } from '../../quotes/quote-notes/quote-notes.component';
import { QuotePage } from '../../shared/models/QuotePage';
import { QuoteBus } from '../../shared/models/QuoteBus';
import { QuoteService } from '../../shared/services/quote.service';
import { AdditionalQuoteData } from '../../shared/models/AdditionalQuoteData';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { PrintService } from '@app/cp/shared/services/print.service';
import { UseCPLoader, ICPLoader } from '@app/cp/shared/decorators/cploader/cploader-decorator';

@UseCPLoader()
@Component({
    selector: 'quote-picker',
    templateUrl: './quote-picker.component.html',
    styleUrls: ['./quote-picker.component.scss']
})
export class QuotePickerComponent extends BaseDQOIComponent<QuoteBus, QuoteService, AdditionalQuoteData, QuotePage> {
    compLoader: ICPLoader = this as any;
    appCode: string = "Dispatch";
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, svc_dqoi: DQOIService, svc_data: QuoteService, private svcDispatch_data: DispatchesService, qry_rd: DQOIReferenceDataQuery, private printService: PrintService) {
        super(globals, featureFlagService, svc_dqoi, qry_rd);
        this.svc_data = svc_data;
        this.addtlDataClass = "AdditionalDispatchData";
        this.pageData = new QuotePage(svc_data, svcDispatch_data);
        this.searchTarget = SearchTarget.dispatch;
        this.saveMode = SaveMode.all;
    }
    @ViewChild("LineItems") lineItemsComp: QuoteLineItemsComponent;
    @ViewChild("Notes") notesComp: QuoteNotesComponent;

    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();

    get saveMode_Notes(): any {
        let saveMode = this.saveMode;
        if (this.hasReferenceData) {
            if (this.serviceMode === "1") {
                saveMode = SaveMode.individual;
            }
        }
        return saveMode;
    }
    get saveMode_Attachments() : any {
        let saveMode = this.saveMode;
        if (this.hasReferenceData) {
            if (this.referenceData.serviceMode === "1" && this.rights.FG2RegularAccess != true) {
                saveMode = SaveMode.individual;
            }
        }
        return saveMode;
    }
    get readOnly_ServiceMode(): boolean {
        return this.serviceMode === "1" ? false : this.readOnly;
    }
    get canEditChild_Notes(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && ((this.canSave && this.saveMode === SaveMode.all) || this.hasId));
    }
    get canEditChild_Attachments(): boolean {
        return this.customFormValidation() && ((this.saveMode == SaveMode.individual || !this.readOnly) && (this.canSave || this.hasId));
    }
    get isDirty(): boolean {
        return !this.readOnly_ServiceMode && this.hasEditForm && this.editForm.dirty;
    }

    setFormAddtl() {

    }
    setFormLocation(data: v_LocationDetailBus) {
        if (!this.hasId) {
            this.editForm.patchValue({
                notToExceed: data.nte
            });
        }
    }
    get hasAccountClass(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.accountClassId);
    }
    get hasStatus(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.dispatchStatusId);
    }
    get hasRcvdDate(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.receivedDateTime);
    }
    get hasRcvdPerson(): boolean {
        return this.hasEditForm && CommonFunctions.hasValue(this.editForm.value.receivedById);
    }
    get statusId(): any {
        return this.hasStatus ? this.editForm.value.dispatchStatusId : null;
    }

    customFormValidation() {
        return super.customFormValidation();
    }

    onCPWindowClosed(e) {
        this.refreshData(DbTable.DispatchAssignments);
        super.onCPWindowClosed(e);
    }

    parentdropEvent(e) {
        this.dropEvent.emit(e);
    }
    origGridData: DispatchSummary[] = new Array();
    gridData: DispatchSummary[];

    createNew(busObj: QuoteBus) {
        return new QuoteBus(busObj);
    }
    override ngOnInit() {
        super.ngOnInit();
    }
    public setId(id: String, disptachId: string) {
        if (!id) { this.getDispatchData(disptachId); }
        else {
        this.id = id;
        this.getData();
        }

    }
    getDispatchData(disptachId: string) {
        super.getData();
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svcDispatch_data.get(disptachId).subscribe(data => {
            this.id = data.quoteId;
            if (this.id) {
                this.getData();
            }
        });

    }
    getData() {
        super.getData();
        CommonFunctions.unsubscribe(this.subs_data);
        this.subs_data = this.svc_data.get(this.id).subscribe(data => {
            this.setData(data);
            this.getDetailData();
        });

    }

    getDetailData() {
        CommonFunctions.unsubscribe(this.subs_dataAddInfo);
        this.subs_dataAddInfo = this.svc_data.getAdditionalData(this.id).subscribe(data => {
            this.addtlData = new AdditionalQuoteData(data);
            this.setFormAddtl();
            if (this.data && this.data.quoteId) {

            }
        });
    }

    refreshData(refreshTarget: DbTable) {
        if (!CommonFunctions.hasValue(refreshTarget)) {
            super.refreshData(null);
        }
        switch (refreshTarget) {
            case DbTable.DispatchAssignments:
                break;
        }
    }
    refreshDQOI() {
        let id: any = this.id;
        this.clear();
        this.getDataFromId(id);
    }
    protected resetData(dqoiItem: DQOIItem) {
        super.resetData(dqoiItem);
        if (dqoiItem.hasDispatchId) {
            this.id = dqoiItem.dispatchId;
            this.getData();
        }
    }
    setDQOIItem(id: any) {
        let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
        let busObj: DQOIItem = new DQOIItem(item);
        busObj.dispatchId = id;
        this.svc_dqoi.setDQOIItem(busObj);
    }
    setDQOIState() {
        let data: DQOIState = this.svc_dqoi.getDQOIState();

        data.dispatchId = this.data.dispatchId;
        if (!this.settingFromDQOIState) {
            data.customerId = this.data.customerId;
            data.invoiceId = this.data.invoiceId;
            data.quoteId = this.data.quoteId;
        }

        this.svc_dqoi.nextDQOIState(data);
        this.settingFromDQOIState = false;

        if (CommonFunctions.hasValue(this.dqoiIndex) && this.dqoiIndex > 0) {
            let item: DQOIItem = this.svc_dqoi.getDQOIItem(this.dqoiIndex);
            this.setCommon(item);
        }
    }
    protected setCommon(dqoiItem: DQOIItem) { }
    onTabSelect(e: SelectEvent) {

    }

    createDraw() {

    }

    itemDisabled(itemArgs: { dataItem: any, index: any }) {
        return !itemArgs.dataItem.canSelect;
    }
    canEditLab() {
        return this.rights.EditLabor;
    }
    canEditContractPrice() {
        return this.rights.EditContractPrice;
    }
    get canDelete(): boolean {
        return (this.hasId || (this.hasData && this.data.isAdded)) && this.rights.DeleteDispatch && this.serviceMode !== "1";
    }
    refreshMessage(event: any) {
        this.pageData.getDispatchAttachments(this.id);

    }
    get canEdit(): boolean {
        let can: boolean = false;
        return can;
    }

    print() {
        this.compLoader.cpLoader = true;
        this.svc_data.print(this.id).subscribe(data => {
            this.printService.printPdf(data);
            this.compLoader.cpLoader = false;
        });
    }

    patchStatus(statusId: any) {
        this.editForm.patchValue({
            dispatchStatusId: statusId
        });

    }

    canEditRight(code: string) {
        return false;
    }
    canEditLabor() {
        return true;
    }
    callBackSearch: boolean = false;
    doCallBackSearch(code: string) {
        if (code === "CLEAR") {
            this.setCallback(null, null);
        }
        else {
            this.callBackSearch = true;
        }
    }
    setCallback(id: any, number: string) {
        this.editForm.patchValue({
            callbackId: id,
            callbackNumber: number
        });
        this.setDirty();
    }
    callBackSelected(value: any) {
        this.callBackSearch = false;
        if (value != null) {
            this.setCallback(value.DispatchId, value.DispatchNumber);
            //this.editForm.patchValue({
            //    callbackId: value.DispatchId,
            //    callbackNumber: value.DispatchNumber
            //});
        }
    }

    quotePickerClosed(e: any) {
        this.closeEvent.emit(null);
    }
    //protected setCommon(dqoiItem: DQOIItem) {
    //        if (dqoiItem.hasDispatchId) {
    //            this.common.addParam("DispatchId", dqoiItem.dispatchId);
    //            this.common.addParam("DispatchNumber", dqoiItem.dispatchNumber);
    //            this.common.addParam("DispatchAccountClassId", dqoiItem.dispatchAccountClassId);
    //        }
    //}

}

